import { default as MascotteWaving } from '$assets/icons/mascotte-waving.svg?raw';
import { default as MascotteCelebrating } from '$assets/icons/mascotte-celebrating.svg?raw';
import { default as MascotteShowing } from '$assets/icons/mascotte-showing.svg?raw';
import { default as MascotteThinking } from '$assets/icons/mascotte-thinking.svg?raw';

export const mascottes = {
  MascotteWaving,
  MascotteCelebrating,
  MascotteShowing,
  MascotteThinking,
};
